<template>
  <rect width="18" height="18" rx="1.63636" fill="#C2C6CD" fill-opacity="0.2" />
  <g opacity="0.4">
    <path
      d="M6.2002 7.80029L9.00019 4.60029L11.8002 7.80029"
      stroke="#868D9C"
      stroke-width="1.6"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9 5V13.4"
      stroke="#868D9C"
      stroke-width="1.6"
      stroke-linecap="round"
    />
  </g>
</template>
